import React from "react";
import { ArcBox } from "@src/core/ui";
import {
  OrderEntity,
  OrderMissionEntity,
  OrderStatusEnum,
} from "@src/features/order/entities";
import ArcOrderCardDetails from '@src/core/components/arc-order-card-details';
import { SxProps } from "@mui/material";

interface ArcOrderCardProps {
  order: OrderEntity | OrderMissionEntity;
  isSelected: boolean;
  onClick: () => void;
  index: number;
  status?: OrderStatusEnum;
  fullWidth?: boolean;
  sx?: SxProps;
  isInFlight?: boolean;
}

const ArcOrderCard: React.FC<ArcOrderCardProps> = ({
  order,
  isSelected,
  onClick,
  index,
  status,
  fullWidth = false,
  sx,
  isInFlight = false,
}) => {

  return (
    <ArcBox
      key={index}
      p={1.5}
      width={fullWidth ? "100%" : "calc(50% - 4px)"}
      bgcolor={status === OrderStatusEnum.ERROR ? "rose.main" : "grey.900"}
      borderRadius={1}
      sx={{
        cursor: "pointer",
        "&:hover": {
          bgcolor: status === OrderStatusEnum.ERROR ? "rose.main" : "grey.800",
        },
        border: "1px solid",
        borderColor: isSelected
          ? "brand.main"
          : status === OrderStatusEnum.ERROR
            ? "rose.main"
            : "grey.900",
        ...sx,
      }}
      onClick={onClick}
    >
      <ArcOrderCardDetails order={order} fullWidth={fullWidth} isInFlight={isInFlight} />
    </ArcBox>
  );
};

export default ArcOrderCard;
